import React from 'react';
// ui
import { Typography } from 'rmwc/Typography';
import { Button } from 'rmwc/Button';
// comps
import Acknowledgements from '../components/Acknowledgements';
import Photo from "../components/Photo";
import history from "../history";

const AboutTheProject = () => {
    return (
        <div className={'app--page'}>

            <div className="app--page-content">
                <div className="app--section">

                    <Typography use={'headline3'} tag={'h1'}
                                style={{ textAlign: 'center' }}>
                        About the project
                    </Typography>

                    <Typography use={'body1'} tag={'div'}>
                        In commemoration of the young men of Dalton-in-Furness
                        and Newton-in-Furness who gave their lives in World War
                        One.
                    </Typography>

                    <video width="100%" controls style={{ padding: '30px 0' }}>
                        <source src="./about_poppy_plaques_sq.mov"
                                type="video/mp4"/>
                        <source src="./about_poppy_plaques_sq.mov"
                                type="video/ogg"/>
                        Your browser does not support the video tag.
                    </video>


                    {/*<Typography use={'headline3'} tag={'h2'} style={{ textAlign: 'center' }}>
                        1914 - 1918
                    </Typography>*/}

                    <Typography use={'body1'} tag={'p'}>
                        A century ago nearly 180 men from Dalton-in-Furness and
                        nearby Newton left to fight in the First World War and
                        never made it back.
                    </Typography>
                    <Typography use={'body1'} tag={'p'}>
                        In 2018 Dalton Town Council joined forces with Up for
                        Arts Cumbria to remember them and the events that marked
                        the end of the war as the broken and bereaved went about
                        rebuilding their lives.
                    </Typography>
                    <Typography use={'body1'} tag={'p'}>
                        Thanks to support from the Heritage Lottery Fund, Poppy
                        Plaques have been made for every house still standing in
                        Dalton from which a WW1 soldier left but did not return.
                    </Typography>
                    <Typography use={'body1'} tag={'p'}>
                        Dalton artist and teacher Adrian Newnham joined children
                        from all four local primary schools and members of Age
                        UK to lead some intergenerational potting sessions,
                        creating the ceramic tiles, each featuring the iconic
                        poppy and the dates 1914-1918.
                    </Typography>
                    <Typography use={'body1'} tag={'p'}>
                        Each potter learnt a bit about the soldier their tile
                        commemorated, gaining an insight into how the war
                        affected their town, with many households on the same
                        street losing fathers, brothers, sons, husbands and
                        friends.
                    </Typography>
                    <Typography use={'body1'} tag={'p'}>
                        It was made possible thanks to research carried out by
                        Councillor Ann Thurlow who searched census data,
                        regiment records, local press reports and more to find
                        out about the men named on the silent stones of the
                        cenotaphs. That work is gathered it in a book, ‘Who Do
                        You Think They Were?’ and the information on this site
                        is from that work.
                    </Typography>
                    <Typography use={'body1'} tag={'p'}>
                        The research also inspired Dalton Town Band to play The
                        Last Post on the anniversary of the death of each of the
                        town's fallen soldiers. <br/>Watch a <Button dense
                                                                     onClick={() => history.push('/bbcRadioCumbria')}
                                                                     theme={'secondary'}>video
                        clip here</Button>
                    </Typography>
                    <Typography use={'body1'} tag={'p'}>
                        When the tiles were fired and the varnish dry and shiny,
                        Dalton residents and school children joined BBC Radio
                        Cumbria on November 1st, 2018 for a special Poppy
                        Plaques launch event and live outside broadcast with Val
                        Armstrong.
                    </Typography>


                    <Photo img={'img_6027.JPG'}/>

                    <Photo img={'img_6024.JPG'}/>


                    <Typography use={'body1'} tag={'p'}>
                        There were songs of peace as well as tea, trench cake
                        and interesting WW1-era bakes from this <a
                        href={'https://drive.google.com/open?id=1F4Q-yAUnlCMESji4RGHtuD6emtCW64k6'}> Dalton
                        recipe
                        pamphlet</a> unearthed from the Cumbria archives by
                        Susan
                        Benson.
                    </Typography>

                    <Typography use={'body1'} tag={'p'}>
                        Three specially-commissioned poems were also performed
                        and broadcast by leading Cumbrian poets Kim Moore, Katie
                        Hale and Kirstie Pelling, you can hear their moving
                        poems here.
                        <a href={'https://soundcloud.com/up-for-arts-cumbria'}> https://soundcloud.com/up-for-arts-cumbria</a>
                    </Typography>

                    <Typography use={'body1'} tag={'p'}>
                        The Barrow Archive and Local Studies Centre brought the
                        Church Record tomes and logged into online resources to
                        help allcomers discover their WW1 connections and trace
                        their family history.
                    </Typography>
                    <Typography use={'body1'} tag={'p'}>
                        More features broadcast as part of the project can be
                        found here:
                        <a href={'https://soundcloud.com/up-for-arts-cumbria'}> https://soundcloud.com/up-for-arts-cumbria</a>
                        <a href={'https://www.facebook.com/upforartscumbria'}> facebook.com/upforartscumbria</a>
                    </Typography>

                    <hr style={{ marginTop: 50, marginBottom: 30 }}/>

                    <Typography use={'headline4'} tag={'h2'}>
                        Displaying a Poppy Plaque
                    </Typography>

                    <Typography use={'body1'} tag={'p'}>
                        If you have any further information about a Dalton
                        soldier named on this site or a query about displaying a
                        poppy plaque, contact Fiona Thomson at Dalton Town
                        Council, <a
                        href="mailto:townclerk@daltoncouncil.org.uk"
                        target="_top">townclerk@daltoncouncil.org.uk</a>, 01229
                        464000.
                    </Typography>


                    <hr style={{ marginTop: 50, marginBottom: 30 }}/>


                    <Photo img={'cenotaph_488x650.jpeg'}
                           caption={'The Dalton War Memorial on Station Road'}/>


                    <div className="app--section">
                        <Typography use={'headline5'} tag={'h2'}
                                    style={{ textAlign: 'center' }}>
                            Who do you think they were?
                        </Typography>

                        <Typography use={'body1'} tag={'p'}
                                    style={{ fontStyle: 'italic', borderTop: '1px solid rgba(0,0,0,0.4)', borderBottom: '1px solid rgba(0,0,0,0.4)', padding: 10, marginTop: 40 }}>
                            All the research and writing about the war here is
                            by Ann Thurlow. Here she explains how it
                            all began.
                        </Typography>

                        <Typography use={'body1'} tag={'p'}>
                            I first became interested in the Great War at
                            school, when studying the War Poets for A
                            level.
                            Later, while researching my family history, I found
                            my Great Uncle Albert Abraham Knight,
                            born
                            in
                            the East End of London, one of eleven children, was
                            killed in action near Vimy Ridge in
                            1916.
                        </Typography>

                        <Typography use={'body1'} tag={'p'}>
                            In 2008 I was able to go to France to visit his
                            grave at Cabaret Rouge Cemetery. Like many
                            others
                            who make such a pilgrimage I was profoundly moved by
                            the experience. To stand in a place
                            where
                            gravestones stretch as far as the eye can see, where
                            there is now a tranquility that belies
                            the
                            terror of what went on there all those years ago,
                            cannot fail to bring anyone close to
                            tears.
                        </Typography>

                        <Typography use={'body1'} tag={'p'}>
                            So I would like to dedicate this work to my Great
                            Uncle and all those young men of
                            Dalton
                            who
                            didn’t walk the long, long trail back home.
                        </Typography>
                        <Typography use={'body1'} tag={'p'}
                                    style={{ textAlign: 'center' }}>
                            To Sgt (1652) Albert A Knight of the City of London
                            Rifles who was killed in action on March
                            30th 1916 aged 22 and is buried at Cabaret Rouge
                            Cemetery, Souchez near Arras, Northern France.
                            And to his brothers in arms from Dalton with Newton,
                            Lancashire (now Cumbria).
                        </Typography>
                    </div>


                    <Typography use={'body1'} tag={'p'}
                                style={{ textAlign: 'center' }}>
                        In Flanders Field <br/>
                        By John McCrae, May 1915<br/>
                        <br/>
                        In Flanders fields the poppies blow<br/>
                        Between the crosses, row on row,<br/>
                        That mark our place; and in the sky<br/>
                        The lark, still bravely singing, fly<br/>
                        Scarce heard amid the guns below.<br/>
                        <br/>
                        We are the Dead. Short days ago<br/>
                        We lived, felt dawn, saw sunset glow,<br/>
                        Loved and were loved, and now we lie<br/>
                        In Flanders fields.<br/>
                    </Typography>

                    <Typography use={'body1'} tag={'p'}>
                        This poem was written by a young Canadian doctor serving
                        on the Western Front. He had to
                        conduct
                        operations on severely wounded men in a bunker behind
                        the lines, with little in the way of
                        medical
                        resources.
                    </Typography>

                    <Typography use={'body1'} tag={'p'}>
                        There is a third verse, but for me the words above sum
                        up the pity of war. Without going
                        into
                        the
                        details of why it happened and whether it should have
                        happened this poem says what did
                        happen.
                        Young
                        men left their homes, their families and friends, to go
                        to a place that was hell on earth,
                        because
                        they believed it to be their duty. Many survived, some
                        with terrible physical and mental
                        injuries.
                        But many did not survive, and it is those young men I
                        wish to honour with this work.
                    </Typography>
                </div>


                <Photo img={'cenotaph-names-2_488x332.jpeg'}
                       caption={'One of the name plaques on the Dalton cenotaph'}/>

                <Acknowledgements/>
                <Photo img={'img_6035.JPG'}/>
            </div>
        </div>
    )
};

export default AboutTheProject;



// WEBPACK FOOTER //
// ./src/app/pages/AboutTheProject.js